<template>
  <div>Logout</div>
</template>

<script>
export default {
  beforeCreate: function() {
    this.$store
      .dispatch("logoutUser")
      .then(() => this.$router.push("/"))
      .catch(err => console.log(err));
  }
};
</script>

<style lang="scss">

</style>